import { render, staticRenderFns } from "./ncbc_home.vue?vue&type=template&id=100d69fa&scoped=true"
import script from "./ncbc_home.vue?vue&type=script&lang=js"
export * from "./ncbc_home.vue?vue&type=script&lang=js"
import style0 from "./ncbc_home.vue?vue&type=style&index=0&id=100d69fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100d69fa",
  null
  
)

export default component.exports